import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2, LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { DataVehicles, ErrorType } from '@esportal/portal-service';
import { EmptyPersonVehicle } from '../components/empty-person-vehicle';
import { PersonVehicles } from '../components/person-vehicles';
import { useTrackingManager } from '../../../tracking/useTrackingManager';

export const VehicleManagerLayer: React.FC<{
	className: string;
	vehicles: DataVehicles | null;
	setIsJourneyLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	isJourneyLayerVisible: boolean;
	setIsAlertLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	layerRef: React.RefObject<LayerHandleV2<any>>;
	alertLayerRef: React.RefObject<LayerHandleV2<any>>;
	setErrorType: React.Dispatch<React.SetStateAction<ErrorType>>;
}> = ({
	vehicles,
	isJourneyLayerVisible,
	setIsJourneyLayerVisible,
	setIsAlertLayerVisible,
	layerRef,
	setErrorType,
}) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);

	const trackingManager = useTrackingManager();

	const handleClose = () => {
		setIsJourneyLayerVisible(false);
		trackingManager.trackClubVWLayerCloseClick('Person Vehicles Layer', {
			contentId: 'Person Vehicles',
		});

		if (layerRef?.current) {
			layerRef?.current.close();
			return ((layerRef.current as any) = null);
		}
		return null;
	};

	const renderJourneyLayer = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<Container
					horizontalAlign={'flex-end'}
					padding={{
						top: ContainerPadding.dynamic0100,
						right: {
							[Breakpoints.default]: ContainerPadding.grid001,
							[Breakpoints.b1600]: ContainerPadding.dynamic0100,
						},
						bottom: ContainerPadding.dynamic0100,
					}}
				>
					<CTA
						tag="button"
						emphasis="tertiary"
						onClick={handleClose}
						aria-label="Close pop-up"
						icon={<Close variant="default" aria-hidden />}
					/>
				</Container>
				{vehicles && vehicles.vehicles.length > 0 ? (
					<PersonVehicles
						vehicles={vehicles}
						setIsJourneyLayerVisible={setIsJourneyLayerVisible}
						setIsAlertLayerVisible={setIsAlertLayerVisible}
						layerRef={layerRef}
						setErrorType={setErrorType}
					/>
				) : (
					<EmptyPersonVehicle
						setIsJourneyLayerVisible={setIsJourneyLayerVisible}
						setIsAlertLayerVisible={setIsAlertLayerVisible}
						layerRef={layerRef}
						setErrorType={setErrorType}
					/>
				)}
			</PortalContext.Provider>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!layerRef.current && isJourneyLayerVisible) {
			const layer = layerManager.openFocusLayer(
				renderJourneyLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(layerRef.current as any) = layer;
		}
		return null;
	};

	return <>{isJourneyLayerVisible && renderInteractionLayer()}</>;
};
